exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".insurance-tools{margin-bottom:40px}.insurance-tools h3{margin-bottom:28px}.insurance-tools .tool-container{display:inline-flex}.card-horizontal{font-size:14px;width:370px;height:93px;box-shadow:0px 2px 3px rgba(23,23,37,.2) !important}.peoduct-head{padding-left:15px;padding-right:15px;padding-bottom:10px;padding-top:30px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/dist/cjs.js!./src/components/Home/InsuranceTools.scss
// module id = 7505
// module chunks = 101